import { Icon } from '@livable/saas-react-components';
import { Button, Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { EnrollmentModal } from 'src/components/resident/EnrollmentModal';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
// import { buildingTenantsArray } from 'src/configs/sampleData';
// import PostChargeModal from 'src/components/resident/PostChargeModal';

export const ActionsBar = observer(() => {
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const page = 'Dashboard Page';

  // const postChargeTrigger = (
  //   <Button variant="action">
  //     <Icon type="coin" />
  //     {t('general.post_charge_or_credit')}
  //   </Button>
  // );

  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 10,
    columnSpacing: 10,
    className: classes.actions
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: !store.company.companyFeatureStore.disableEnrollResident ? 6 : 12,
    md: !store.company.companyFeatureStore.disableEnrollResident ? 4 : 12,
    lg: true
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "action",
    component: RouterLink,
    to: "/allocations",
    'custom-attribute': '528-dashboard-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "table"
  }), t('dashboard_page.process_bills'))), !store.company.companyFeatureStore.disableEnrollResident && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4,
    lg: true
  }, /*#__PURE__*/React.createElement(EnrollmentModal, {
    page: page
  }))), !store.company.companyFeatureStore.disableAddNewProperty && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4,
    lg: true
  }, /*#__PURE__*/React.createElement(Button, {
    id: "addNewProperty",
    variant: "action",
    component: RouterLink,
    to: "/new_property",
    'custom-attribute': '529-dashboard-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "building"
  }), t('add_new_property_flow.add_new_property'))));
});